import { ConfigContext } from '@/components/ConfigProvider';
import { useContext } from 'react';

export const useLangContext = () => {
  const { lang } = useContext(ConfigContext);
  return { lang };
};
